import { sdkReadyPromise } from '../../platform/loader';
import { getEncryptPublicKey } from './get_public_key';
/**
 * 测试浏览器是否具有所有所需的 API
 * @returns 浏览器是否兼容
 */
const isCompatibleWebCrypto = () => {
    if (!window.TextEncoder)
        return false; // 没有 TextEncoder
    if (!window.crypto?.subtle?.importKey || !window.crypto?.subtle?.encrypt)
        return false; // 没有加密 API
    if (!window.Uint8Array)
        return false; // 没有 TypedArray
    if (!window.btoa)
        return false;
    if (!String.fromCharCode)
        return false;
    return true;
};
/**
 * 使用浏览器自带 API 加密
 * @param data - 需要加密的数据
 * @param publicKey - public key
 * @returns 加密的结果
 */
const encryptByBrowser = async (data, publicKey) => {
    if (!data)
        throw new Error('加密方法必须传入要加密的内容。');
    const str = typeof data === 'string' ? data : JSON.stringify(data);
    const encoder = new TextEncoder();
    const iv = encoder.encode(publicKey);
    const key = await window.crypto.subtle.importKey('raw', iv, 'AES-CBC', true, ['encrypt']);
    const encrypted = await window.crypto.subtle.encrypt({
        name: 'AES-CBC',
        iv
    }, key, encoder.encode(str));
    const buffer = new Uint8Array(encrypted);
    return window.btoa(String.fromCharCode(...buffer));
};
/**
 * 异步加载 Crypto JS 并使用 Crypto JS 加密
 * @param data - 要加密的数据
 * @param publicKey - public key
 * @returns 解密的结果
 */
const encryptByCryptoJS = async (data, publicKey) => {
    await sdkReadyPromise('CryptoJS', 'https://ut-static.udache.com/webx/web_static/libs/crypto-js/4.1.1/crypto-js.min.js');
    const str = typeof data === 'string' ? data : JSON.stringify(data);
    const key = window.CryptoJS.enc.Utf8.parse(publicKey);
    const srcs = window.CryptoJS.enc.Utf8.parse(str);
    const encrypted = window.CryptoJS.AES.encrypt(srcs, key, {
        iv: key,
        mode: window.CryptoJS.mode.CBC,
        padding: window.CryptoJS.pad.Pkcs7
    });
    const ciphertext = encrypted.ciphertext.toString();
    const encryptedHexStr = window.CryptoJS.enc.Hex.parse(ciphertext);
    return window.CryptoJS.enc.Base64.stringify(encryptedHexStr);
};
/**
 * 使用接口返回的 public key 通过 AES-CBC 算法加密传入的字符串 / 对象
 * @param data - 要加密的数据
 * @returns 加密的结果
 */
export const setEncrypt = async (data) => {
    const publicKey = await getEncryptPublicKey();
    return isCompatibleWebCrypto()
        ? await encryptByBrowser(data, publicKey)
        : await encryptByCryptoJS(data, publicKey);
};
